/**
 * 全局HTTP拦截
 * @param request
 * @param next
 */
// 安装完axios之后引入
import axios from 'axios'
import store from '../store/index'
let Tem_axios = axios.create()
function getUrlKey (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

Tem_axios.defaults.baseURL = (process.env.NODE_ENV !== 'production' ? '/api2/' : 'https://admin.facaifacai.cn/')
Tem_axios.defaults.params = {XDEBUG_SESSION_START: 18870}
Tem_axios.defaults.headers = {
  'Content-Type': 'application/json'
}
Tem_axios.defaults.withCredentials = true
// -----------设置接口最长请求时间，单位ms
Tem_axios.defaults.timeout = 60000
// -----------有关请求request的过滤器
Tem_axios.interceptors.request.use((request) => {
  let token = getUrlKey('token')
  if (!token || token === 'none') {
    token = localStorage.getItem('token') || ''
  }
  let merchantId = getUrlKey('state')

  if (!token || merchantId) {

  } else {
    request.headers['token'] = token
    console.log(Tem_axios.defaults.headers)
  }
  // -----------判断是否包含有接口的字符串，定制其他加载，把loading换成其他文字，dispatch作用相当于commit
  if (request.data && request.data.noOpenLoading) {
  } else {
    store.dispatch('openLoading')
  }
  return request
}, (error) => {
  console.log(error)
})
// -----------有关响应response的过滤器
Tem_axios.interceptors.response.use((response) => {
  // -----------关闭加载
  setTimeout(() => {
    store.dispatch('closeLoading')
  }, 100)
  // -----------根据后台返回的不同code做出对应处理
  switch (response.data.code) {
    case 200:
      // -----------返回正确信息，用resolve
      return Promise.resolve(response.data)
    default:
      const isIgnoreError = response.config.isIgnoreError // 是否忽略错误
      if (isIgnoreError) {
        // 忽略错误就正常返回
        return Promise.resolve(response.data)
      } else {
        setTimeout(() => {
          store.dispatch('showToast', {msg: response.data.msg, time: 2000})
        }, 200)
        return Promise.reject(response.data)
      }
  }
}, (error) => {
  // -----------请求错误
  store.dispatch('closeLoading')
  if (JSON.stringify(error).indexOf('404') > 0) {
    store.dispatch('showToast', {msg: '系统出错', time: 3000})
  } else {
    store.dispatch('showToast', {msg: '网络出了点问题', time: 3000})
  }
  // -----------返回正确信息，用reject
  return Promise.reject(error)
})

export default Tem_axios



// WEBPACK FOOTER //
// ./src/http/index_new.js